import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from 'moment';
import "../../styles.scss";
import { useUser } from '../../utils/userContext';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import useConfiguration from '../../utils/ConfigurationContext';


export default function Submitclaims() {
    const [loading, setLoading] = useState(false);
    const { user } = useUser();
    console.log("user", user)
    const [showModal, setShowModal] = useState(false);
    const [fileData, setFileData] = useState([]);
    const config = useConfiguration();
    const handleErrors = useHandleErrors();
    const [formData, setFormData] = useState({
        LeaveType: '',
        startDate: moment().format("DD-MM-YYYY"),
        endDate: moment().format("DD-MM-YYYY"),
        Description: '',
        AlternateContactPerson: ''
    });
    const [recurrence, setRecurrence] = useState([]);
    const [file, setFile] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [leaveData, setLeaveData] = useState(null);
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);
    const [employees, setEmployees] = useState([]);

    const handleCloseModal = () => {
        setShowModal(false);

    };

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);

    const handleUpload = () => {
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const binaryData = e.target.result;
                setUploadedFiles((prevFiles) => [...prevFiles, file]);
                setFileData((prevData) => [...prevData, binaryData]);
                setFile(null);
            };
            reader.readAsBinaryString(file);
        }
    };

    const handleDelete = (fileIndex) => {
        setUploadedFiles((prevFiles) => prevFiles.filter((_, index) => index !== fileIndex));
        setFileData((prevData) => prevData.filter((_, index) => index !== fileIndex));
    };

    const handleCancel = (e) => {
        e.preventDefault();
        setFormData({
            LeaveType: '',
            startDate: moment().format("DD-MM-YYYY"),
            endDate: moment().format("DD-MM-YYYY"),
            Description: '',
            AlternateContactPerson: ''
        })
        setRecurrence([])
        setUploadedFiles([])
    };

    const leaveTypeOptions = config?.leaveManagement?.holidayTypes?.map(department => ({
        value: department,
        label: department,
    }));

    const ClearIndicator = () => null;


    const handleEvent = (event, picker) => {
        if (picker && picker.startDate && picker.endDate) {
            setFormData(prevState => ({
                ...prevState,
                startDate: moment(picker.startDate).format("DD-MM-YYYY"),
                endDate: moment(picker.endDate).format("DD-MM-YYYY"),
            }));
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleClick = () => {
        document.querySelector('input[name="startDate"]').focus();
    };


    const handleRecurrenceChange = (day) => {
        // Ensure all days, including Saturday and Sunday, are handled correctly
        setRecurrence((prev) =>
            prev.includes(day)
                ? prev.filter((d) => d !== day)
                : [...prev, day]
        );
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        if (!formData.LeaveType) {
            toast.error("Leave Type is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.startDate) {
            toast.error("Start Date is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.endDate) {
            toast.error("End Date is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (recurrence.length === 0) {
            toast.error("Days of Week is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.Description) {
            toast.error("Description is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.AlternateContactPerson) {
            toast.error("Alternate Contact Person is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        const formDataToSubmit = new FormData();
        const jsonPayload = {
            userEmailId: user?.OfficialEmail,
            leaveType: formData.LeaveType,
            description: formData.Description,
            startDate: moment(formData.startDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
            endDate: moment(formData.endDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
            noOfhours: 8,
            teamLeadEmail: user?.ManagerEmail,
            alternateContactPerson: formData.AlternateContactPerson,
            Recurrence: recurrence // Ensure Recurrence is sent as an array of days
        };
        formDataToSubmit.append("jsonPayload", JSON.stringify(jsonPayload));
        if (uploadedFiles.length > 0) {
            uploadedFiles.forEach((file, index) => {
                formDataToSubmit.append(`MedicalDocuments`, file);
            });
        }

        try {
            const path = "/LeaveTracker/add";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, formDataToSubmit, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            if (response.status === 200) {
                setShowModal(true)
                setFormData({
                    LeaveType: '',
                    startDate: moment().format("DD-MM-YYYY"),
                    endDate: moment().format("DD-MM-YYYY"),
                    Description: '',
                    AlternateContactPerson: ''
                })
                setRecurrence([])
                setUploadedFiles([])
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const toCamelCase = (str) => {
        return str.replace(/\w\S*/g, (word) =>
            word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
        );
    };

    useEffect(() => {
        const fetchLeaveBalance = async () => {
            if (user && user.EmployeeId) {
                const path = `/getLeaveBalance?employeeId=${user.EmployeeId}`;
                const URL = process.env.REACT_APP_BE_URL + path;

                try {
                    const response = await axios.get(URL, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                    });
                    setLeaveData(response.data.userLeaveBalance[0]);
                } catch (error) {
                    console.error('Error fetching leave data:', error);
                }
            }
        };

        if (!hasFetchedRef.current) {
            fetchLeaveBalance();
            fetchEmployees();
            hasFetchedRef.current = true;
        }
    }, [user]);

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const activeEmployees = response.data.onboardEmployeeDetails.filter(emp => emp.Status === 'Active');
                setEmployees(activeEmployees);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const assignToOptions = employees
        .map((emp) => ({
            value: emp.OfficialEmail,
            label: `${emp.OfficialEmail}`,
        }));

    const totalLeaves = leaveData?.leaveBalance.reduce((total, leave) => total + leave.noOfLeaves, 0);
    const approvedRequests = leaveData?.leaveRequests.find(request => request.status.toLowerCase() === 'approved')?.noOfRequests || 0;
    const submittedRequests = leaveData?.leaveRequests.find(request => request.status.toLowerCase() === 'submitted')?.noOfRequests || 0;
    const RejectedRequests = leaveData?.leaveRequests.find(request => request.status.toLowerCase() === 'rejected')?.noOfRequests || 0;

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Leaves</h3>
                        </div>
                        <div className="col-auto"><Link to={'/SubmitTimesheet'} data-extra-toggle="tab" data-target="#timesheet-pan" className="btn btn-primary mt-lg-0 mt-4"><i className="ri-calendar-schedule-fill"></i> Timesheet</Link></div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h5 className="title">
                                        Submit Leave{' '}
                                        <small className="float-right">
                                            Employee Email - <span>{user?.OfficialEmail}</span>
                                        </small>
                                    </h5>
                                    <hr />
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="LeaveType" className="required">
                                                    Leave Type
                                                </label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    name="LeaveType"
                                                    value={leaveTypeOptions?.find(
                                                        (option) => option.value === formData.LeaveType
                                                    ) || null}
                                                    onChange={(selectedOption) =>
                                                        setFormData({
                                                            ...formData,
                                                            LeaveType: selectedOption ? selectedOption.value : '',
                                                        })
                                                    }
                                                    options={leaveTypeOptions}
                                                    components={{ ClearIndicator }}
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="billingDateRange" className="required">
                                                    Date Range
                                                </label>
                                                <div className="input-group dateRange">
                                                    <DateRangePicker
                                                        initialSettings={{
                                                            startDate: moment(formData.startDate, 'DD-MM-YYYY').toDate(),
                                                            endDate: moment(formData.endDate, 'DD-MM-YYYY').toDate(),
                                                            locale: {
                                                                format: 'DD-MM-YYYY',
                                                            },
                                                        }}
                                                        onEvent={handleEvent}
                                                    >
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="startDate"
                                                            placeholder="Select Date"
                                                            value={`${formData.startDate} - ${formData.endDate}`}
                                                            onChange={handleChange}
                                                        />
                                                    </DateRangePicker>
                                                    <div className="input-group-append">
                                                        <span className="input-group-text bg-white"
                                                            onClick={handleClick}
                                                        >
                                                            <i className="ri-calendar-2-line"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="costDetails" className="required">Days of Week</label>
                                                <div
                                                    className="d-flex"
                                                    style={{
                                                        flexWrap: 'nowrap',
                                                        overflowX: 'auto',
                                                        justifyContent: 'space-between', // evenly spaced
                                                        gap: '8px',                      // equal gap between items
                                                    }}
                                                >
                                                    {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day) => (
                                                        <div
                                                            key={day}
                                                            style={{
                                                                flex: '1',                   // each takes equal width
                                                                boxSizing: 'border-box',
                                                                textAlign: 'center',         // center text/checkbox
                                                            }}
                                                        >
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id={`${day}Day`}
                                                                    checked={recurrence.includes(day)}
                                                                    onChange={() => handleRecurrenceChange(day)}
                                                                />
                                                                <label
                                                                    className="custom-control-label control-label-1"
                                                                    htmlFor={`${day}Day`}
                                                                >
                                                                    {day}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="description" className="required">Description</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="7"
                                                    name="Description"
                                                    value={formData.Description}
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="Document">
                                                    Document
                                                </label>
                                                <div className="d-flex align-items-center">
                                                    <div className="custom-file mr-2">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id="Document"
                                                            onChange={handleFileChange}
                                                        />
                                                        <label className="custom-file-label" htmlFor="uploadEmpofferletter">
                                                            {file ? file.name : 'Choose a file'}
                                                        </label>
                                                    </div>
                                                    <button type="button" className="btn btn-secondary" onClick={handleUpload}>
                                                        Upload
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="container-fluid my-2 px-0">
                                                <div className="row">
                                                    {uploadedFiles?.map((file, index) => (
                                                        <div key={index} className="col-6 mb-2">
                                                            <button
                                                                className="btn btn-link text-danger btn-action"
                                                                type="button"
                                                                onClick={() => handleDelete(index)}
                                                            >
                                                                <i className="ri-delete-bin-6-line" />
                                                            </button>
                                                            <a href="#" onClick={() => window.open(URL.createObjectURL(file), '_blank')}>
                                                                {file.name}
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="AlternateContactPerson" className="required">Alternate Contact Person</label>
                                                {/* <input
                                                    className="form-control"
                                                    name="AlternateContactPerson"
                                                    placeholder='Enter Email Id'
                                                    value={formData.AlternateContactPerson}
                                                    onChange={handleChange}
                                                ></input> */}
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    name="AssignTo"
                                                    value={assignToOptions?.find(option => option.value === formData.AlternateContactPerson) || null}
                                                    onChange={(selectedOption) =>
                                                        setFormData({
                                                            ...formData,
                                                            AlternateContactPerson: selectedOption ? selectedOption.value : '',
                                                        })
                                                    }
                                                    options={assignToOptions}
                                                    placeholder="select..."
                                                    isClearable
                                                    components={{ ClearIndicator }} // if you want to customize components
                                                    menuPortalTarget={document.body} // for positioning the menu
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                        control: base => ({ ...base, zIndex: 1 })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="costDetails" className="required">
                                                    Manager Email
                                                </label>
                                                <input
                                                    className="form-control-plaintext"
                                                    type="email"
                                                    value={user?.ManagerEmail}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card ww-app-bg">
                                <div className="card-body">
                                    <span><i className="ri-calendar-todo-fill"></i></span>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h4 className="mb-2">Leave Balance</h4>
                                    <div className="row text-center border-bottom">
                                        <div className="col-lg-12 col-md-12 border-bottom">
                                            <div>
                                                <label>Total Leaves</label>
                                                <h4 className="text-success">{totalLeaves}</h4>
                                            </div>
                                        </div>
                                        {leaveData?.leaveBalance?.slice(0, 3).map((leave, index) => (
                                            <div className={`col-lg-4 col-md-4 col-sm-4 ${index !== 0 ? 'border-right border-left' : ''}`} key={index}>
                                                <div className={`claim-history-box ${leave.leaveType.toLowerCase().replace(' ', '-')}-count`}>
                                                    <label> {toCamelCase(leave.leaveType)}</label>
                                                    <h4 className="text-info">{leave.noOfLeaves}</h4>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="row text-center border-bottom collapse" id="moreLeaves">
                                        {leaveData?.leaveBalance?.slice(3).map((leave, index) => (
                                            <div className={`col-lg-4 col-md-4 col-sm-4 ${index !== 0 ? 'border-right border-left' : ''}`} key={index}>
                                                <div className={`claim-history-box ${leave.leaveType.toLowerCase().replace(' ', '-')}-count`}>
                                                    <label> {toCamelCase(leave.leaveType)}</label>
                                                    <h4 className="text-info">{leave.noOfLeaves}</h4>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="text-center mt-2">
                                        <a href="#" data-toggle="collapse" data-target="#moreLeaves">More Leaves</a>
                                    </div>
                                    <div className="row text-center">
                                        <div className="col-lg-12 col-md-12 border-bottom">
                                            <p className="mt-3">Quick summary of all submitted requests.</p>
                                            <div>
                                                <label>Total Requests</label>
                                                <h4>{approvedRequests + submittedRequests}</h4>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-4">
                                            <div className="claim-history-box pending-count">
                                                <label>Pending</label>
                                                <h4 className="text-warning">{submittedRequests}</h4>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-4 border-right border-left">
                                            <div className="claim-history-box approved-count">
                                                <label>Approved</label>
                                                <h4 className="text-success">{approvedRequests}</h4>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-4">
                                            <div className="claim-history-box rejected-count">
                                                <label>Rejected</label>
                                                <h4 className="text-light">{RejectedRequests}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row fixed-footer">
                <div className="col-lg-12 text-center">
                    <button type="reset" className="btn btn-light" onClick={handleCancel}>Clear</button>
                    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Submit <i className="ri-checkbox-circle-line"></i></button>
                </div>
            </div>
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="successModalModalLabel">Success!</h6>
                                <button className="close" type="button" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-12 text-success text-center"><i className="ri-checkbox-circle-fill"></i></div>
                                    <div className="col-12 text-center">Leave Submitted Successfully.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}